import {
  MARRIED,
  SEPARATED,
  MOTHER,
  FATHER,
  FATHER_IN_LAW,
  MOTHER_IN_LAW,
} from 'constants/enums/relationshipOptions';
import { isPVQForm } from 'helpers/form';
import { ValidateJSModel, ListItemModel } from 'forms/shared/types';
import { parentInfoContainsErrors } from 'helpers/relatives';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { relativesAddressNameFields } from 'constants/enums/people';
import { RelationshipsRelativesModel, RelationshipsRelativeItemModel } from './types';
import { relationshipsRelativeItemValidator } from './validators/item';
import { relationshipsPvqRelativeItemValidator } from './validators/pvqItem';

const relationshipsRelativesValidator: ValidateJSModel<RelationshipsRelativesModel> = {
  List: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        accordion: {
          validator: relationshipsPvqRelativeItemValidator,
        },
      };
    }

    const { maritalStatus } = options;
    let additionalValidation: any = {};

    if (parentInfoContainsErrors(value?.items)) {
      return {
        presence: true,
        requireTrue: { // force error message; value will never be true
          message: 'relationships.relatives.error.duplicateListItems',
        }
      };
    }

    const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, relativesAddressNameFields);
    if (errors.length > 0) {
      additionalValidation = {
        requireTrue: { // force error message; value will never be true
          message: 'relationships.relatives.error.duplicateListItems',
        }
      };
    }

    const requiredRelations = [
      (i: ListItemModel<RelationshipsRelativeItemModel>) => i.Item && i.Item.Relation && i.Item.Relation.value === MOTHER,
      (i: ListItemModel<RelationshipsRelativeItemModel>) => i.Item && i.Item.Relation && i.Item.Relation.value === FATHER,
    ];

    if ([MARRIED, SEPARATED].includes(maritalStatus)) {
      requiredRelations.push(
        (i) => i.Item && i.Item.Relation && i.Item.Relation.value === MOTHER_IN_LAW
      );
      requiredRelations.push(
        (i) => i.Item && i.Item.Relation && i.Item.Relation.value === FATHER_IN_LAW
      );
    }

    return {
      ...additionalValidation,
      presence: true,
      accordion: {
        validator: relationshipsRelativeItemValidator,
      },
      containsRequiredItems: {
        requirements: requiredRelations,
        incompleteRequirements: 'error.relativeRequirements',
      },
    };
  },
  SummaryComments: {},
};

export default relationshipsRelativesValidator;
